import Vue from 'vue'
import Router from 'vue-router'
import home from '@/view/home/index.vue'
import product_society from '@/view/product/society/index.vue'
import product_manufacture from '@/view/product/manufacture/index.vue'
import product_manufacture_category from '@/view/product/manufacture/categoryDetail.vue'
import product_finance from '@/view/product/finance/index.vue'
import product_operationDecision from '@/view/product/operationDecision/index.vue'
import product_operationDecision_category from '@/view/product/operationDecision/categoryDetail.vue'
import product_digitization from '@/view/product/digitization/index.vue'
import product_architecture from '@/view/product/productArchitecture/index.vue'
import product_cognitive from '@/view/product/cognitive/index.vue'
import ecological_coreTechnology from '@/view/ecological/coreTechnology/index.vue'
import ecological_waic from '@/view/ecological/waic/index.vue'
import ecological_waic_detail from '@/view/ecological/waic/detail.vue'
import ecological_institute from '@/view/ecological/institute/index.vue'
import legalNotice from '@/view/otherFunction/legalNotice.vue'
import partner from '@/view/otherfunction/partner.vue'
import siteMap from '@/view/otherfunction/siteMap.vue'
import news from '@/view/news/index.vue'
import newsDetail from '@/view/news/detail.vue'
import about from '@/view/about/index.vue'
import addUs from '@/view/addUs/index.vue'

Vue.use(Router)


// //获取原型对象上的push函数
// const originalPush = Router.prototype.push
// //修改原型对象中的push方法
// Router.prototype.push = function push(location) {
//    return originalPush.call(this, location).catch(err => err)
// }

const router = new Router({
  // 带#
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'index',
      component: home,
      meta: { menuactive: 0 }
    },
    {
      path: '/productSociety',
      name: 'product_society',
      component: product_society,
    },
    {
      path: '/productManufacture',
      name: 'product_manufacture',
      component: product_manufacture,
    },
    {
      path: '/productManufacture/category/:key',
      name: 'product_manufacture_category',
      component: product_manufacture_category,
    },
    {
      path: '/productFinance',
      name: 'product_finance',
      component: product_finance,
    },
    {
      path: '/operationDecision',
      name: 'product_operationDecision',
      component: product_operationDecision,
    },
    {
      path: '/operationDecision/category/:key',
      name: 'product_operationDecision_category',
      component: product_operationDecision_category,
    },
    {
      path: '/productDigitization',
      name: 'product_digitization',
      component: product_digitization,
    },
    {
      path: '/productArchitecture',
      name: 'product_architecture',
      component: product_architecture,
    },
    {
      path: '/productCognitive',
      name: 'product_cognitive',
      component: product_cognitive,
    },
    {
      path: '/ecologicalCoreTechnology',
      name: 'ecological_coreTechnology',
      component: ecological_coreTechnology,
    },
    {
      path: '/ecologicalWaic',
      name: 'ecological_waic',
      component: ecological_waic,
    },
    {
      path: '/ecologicalWaicDetail',
      name: 'ecological_waic_detail',
      component: ecological_waic_detail,
    },
    {
      path: '/ecologicalInstitute',
      name: 'ecological_institute',
      component: ecological_institute,
    },
    {
      path: '/siteMap',
      name: 'siteMap',
      component: siteMap,
    },
    {
      path: '/legalNotice',
      name: 'legalNotice',
      component: legalNotice,
    },
    {
      path: '/partner',
      name: 'partner',
      component: partner,
    },
    {
      path: '/news',
      name: 'news',
      component: news,
    },
    {
      path: '/newsDetail',
      name: 'newsDetail',
      component: newsDetail,
    },
    {
      path: '/about',
      name: 'about',
      component: about,
    },
    {
      path: '/addUs',
      name: 'addUs',
      component: addUs,
    },
    {
      path: '/joinUs',
      name: 'joinUs',
      component: addUs,
    },
    {
      path: '*', // 页面不存在的情况下会跳到首页面
      redirect: '/'
    }
  ]
})

router.beforeEach((to, from, next) => {
  document.documentElement.scrollTop = 0;
  next();
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js